import { ResourceProps } from "@refinedev/core";
import { TrophyOutlined } from "@ant-design/icons";

export const championAnimationResource: ResourceProps = {
  name: "champions-animation",
  meta: {
    icon: <TrophyOutlined />,
    label: "Анимация чемпионов",
  },
  list: "/champions-animation",
};
